export const environment = {
  production: true,
  connection: {
    name: 'LH Eferding Softline',
    host: 'https://softline.eferding-ooemitte.lagerhaus.at/',
    port: 443,
    basePath: '/api',
  },
  androidUpdateRepository: '',
};
